// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { ApplicationRef, NgModuleRef } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import {default as Version} from './version.json';
import { Environment } from "@app/config/environment.model";

export const environment : Environment  = {
  production: false,
  hmr: false,
  showDevModules: true,
  showAddSubsidiary: true,
  environment: 'dev',
  version: Version.version,
  isBuilderEnabled: true,
  showPayment: false,
  gisURL: '', // set via api/Settings
  gisBaseURL: '',

  /* istanbul ignore next */
  decorateModuleRef(modRef: NgModuleRef<any>) {
    /* istanbul ignore next */
    const appRef = modRef.injector.get(ApplicationRef);
    /* istanbul ignore next */
    const cmpRef = appRef.components[0];
    /* istanbul ignore next */
    const _ng = (<any>window).ng;
    /* istanbul ignore next */
    enableDebugTools(cmpRef);
    /* istanbul ignore next */
    (<any>window).ng.probe = _ng.probe;
    /* istanbul ignore next */
    (<any>window).ng.coreTokens = _ng.coreTokens;
    /* istanbul ignore next */
    return modRef;
  }
};

/* In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

